<template>
  <v-row>
    <template v-if="showFull">
      <div style="width: 100%" class="d-flex d-lg-none">
        <v-col class="pb-0 pt-0" cols="12" md="12">
          <el-simple-table :items="tableItems" />
        </v-col>
      </div>
      <div style="width: 100%" class="d-none d-lg-flex">
        <v-col class="pb-0 pt-0" cols="6">
          <el-simple-table :items="tableItemsR" />
        </v-col>
        <v-col class="pb-0 pt-0" cols="6">
          <el-simple-table :items="tableItemsL" />
        </v-col>
      </div>
    </template>
    <template v-else>
      <v-col class="pb-0 -0 pt-0" cols="12" md="6" lg="3">
        <el-autocomplete
          required
          :disabled="onlyView"
          :items="enumsClassifiers.procurationKind"
          itemvalue="value"
          itemtext="text"
          enums
          label="Prokūros rūšis"
          style="padding-top: 1.5rem"
          v-model="formData.procuracy_type"
          validateKey="type"
          key="type"
        />
      </v-col>
      <v-col class="pb-0 pt-0" cols="12" md="6" lg="3">
        <el-date-picker
          required
          :disabled="onlyView"
          pastDates
          label="Sudarymo data"
          style="padding-top: 1.5rem"
          v-model="formData.formation_date"
          validateKey="formation_date"
          key="formation_date"
        />
      </v-col>
    </template>
  </v-row>
</template>

<script>
import Enums from '@/enums'

export default {
  name: 'DeregistrationData',
  components: {},
  props: {
    formData: [Array, Object],
    showFull: Boolean,
    onlyView: Boolean
  },
  data() {
    return {
      enumsClassifiers: [],
    }
  },
  created() {
    this.enumsClassifiers = Enums
  },
  computed: {
    formatedHasEndedSelect() {
      return { lt: [], en: [] }
    },
    tableItems() {
      let items = [
        {
          title: 'Įregistravimo data',
          value: this.formData.registration_date || '',
        },
        {
          title: 'Identifikavimo kodas',
          value: this.formData.mandate_code || '',
          // enumName: 'StatementStatus',
        },
        {
          title: 'Prokūros rūšis',
          value: this.formData.procuracy_type || '',
          enumName: "procurationKind"
        },
        {
          title: 'Prokūros suteikiamos teisės',
          value: 'atstovaujamojo vardu ir dėl jo interesų atlikti visus teisinius veiksmus, susijusius su juridinio asmens (verslininko) verslu, be to atstovaujamojo vardu ir dėl jo interesų atlikti teisinius veiksmus teisme ir kitose ne teismo institucijose (Lietuvos Respublikos civilinio kodekso 2.176 straipsnio 1 ir 2 dalys)',
          hide: this.formData.mandate_kind !== 'ITPSP'
        },
        {
          title: 'Prokūra ribota',
          value: this.formData.procuracy_restricted ? this.$t('Taip') : this.$t('Ne') || '',
          hide: this.formData.procuracy_restricted == false
        },
        {
          title: 'Prokūros ribojimai',
          value: this.formData.procuracy_restriction || '',
          hide: this.formData.procuracy_restricted == false
        },
        {
          title: 'Terminas',
          value: this.enumsClassifiers.terms.lt[this.formData.term] ?? '',
        },
        {
          title: 'Data apibrėžtas terminas',
          value: this.formData.term_date || '',
        },
      ]
      return items
    },
    tableItemsR() {
      const half = Math.ceil(this.tableItems.length / 2)
      return this.tableItems.slice(0, half)
    },
    tableItemsL() {
      const half = Math.ceil(this.tableItems.length / 2)
      return this.tableItems.slice(half)
    },
  },
}
</script>

<style></style>
